import React from "react";
import { t, Trans } from "@lingui/macro";
import { DArchiveSalesFilters } from "./filters";
import { typeDataSalesRowActions } from "./index";
import { TableBody, TableHeader } from "./tableData";
import { PopupArchivePrint } from "./popupContents/popupPrint";
import { DashboardContentPage } from "../DashboardContentTable";
import { InputSearch } from "../../../UI/InputSearch/InputSearch";
import { ArchivePopupDetails } from "./popupContents/popupDetails";
import { FiltersDashboard } from "../DashboardContentTable/FiltersDashboard";
import { DataTableDashboard } from "../DashboardContentTable/DataTableDashboard";
import { PopupPanelDashboard } from "../DashboardContentTable/PopupPanelDashboard";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";

export type typeViewDataSales = {
  variant?: string;
  searchValue: string;
  isActiveFilters: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openFilterBar: boolean;
  setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>;
  openPopupDetails: boolean;
  setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>;
  openPopupPrint: boolean;
  setOpenPopupPrint: React.Dispatch<React.SetStateAction<boolean>>;
  onCancelPrint: () => void;
  onPrintSubmitClick: () => void;
  onEnterSearch: () => void;
  onClearSearch: () => void;
  setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>;
  rowsActions: typeDataSalesRowActions;
  pagination: typePaginationDashboardObject;
  onChangeSearchValue: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
};

export const ViewComponent: React.FC<typeViewDataSales> = ({
  variant,
  pagination,
  rowsActions,
  searchValue,
  onClearSearch,
  onEnterSearch,
  openFilterBar,
  openPopupPrint,
  setSidebarOpen,
  isActiveFilters,
  setOpenFilterBar,
  openPopupDetails,
  setOpenPopupPrint,
  setIsActiveFilters,
  setOpenPopupDetails,
  onChangeSearchValue,
}) => {
  return (
    <DashboardContentPage
      setSidebarOpen={setSidebarOpen}
      headerTitle={<Trans>Sales</Trans>}
    >
      <FiltersDashboard
        variant={variant}
        filters={{
          openFilterBar: openFilterBar,
          setOpenFilterBar: setOpenFilterBar,
          filtersForm: (
            <DArchiveSalesFilters
              setOpenFilterBar={setOpenFilterBar}
              setIsActiveFilters={setIsActiveFilters}
            />
          ),
        }}
        searchBar={
          <InputSearch
            id="SalesSearch"
            name="SalesSearch"
            value={searchValue}
            onClear={onClearSearch}
            onChange={onChangeSearchValue}
            onKeyEnterDown={onEnterSearch}
            placeholder={t`Search by public sale ID and receipt number.`}
          />
        }
        isActiveFilters={isActiveFilters}
      />

      <DataTableDashboard
        tableHeader={<TableHeader />}
        tableBody={
          <TableBody
            variant={variant}
            rowsActions={rowsActions}
            setOpenPopupDetails={setOpenPopupDetails}
          />
        }
        pagination={pagination}
      />

      <PopupPanelDashboard
        title={<Trans>Details</Trans>}
        openPopup={openPopupDetails}
        setOpenPopup={setOpenPopupDetails}
      >
        <ArchivePopupDetails
          crossLinkToRefund={true}
          setOpenPopup={setOpenPopupDetails}
        />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        title={<Trans>Print</Trans>}
        openPopup={openPopupPrint}
        setOpenPopup={setOpenPopupPrint}
      >
        <PopupArchivePrint setOpenPopup={setOpenPopupPrint} />
      </PopupPanelDashboard>
    </DashboardContentPage>
  );
};
